<template>
<v-layout row justify-center class="billingModule">

   <!-- Queue Table -->
   <v-container v-if="appointmentData.Queue.length && appointmentData.Queue[0].name">
    <v-layout row wrap>
      <v-flex xs10>
        <h1 class="title" style="margin-bottom:20px;">Queue List</h1>
      </v-flex>
      <v-flex xs2>
          <el-button type="danger" v-if="queueListSelections.length" @click="cancelAppointments" >Cancel Appointments</el-button>
      </v-flex>
    </v-layout>
      <v-layout row wrap >
    <el-table
      v-loading="isLoading"
      :data="appointmentData.Queue"
      style="width: 100%"
      v-on:row-click="showProfileModal"
      @selection-change="handleSelectionChange"

    >

       <el-table-column
      type="selection"
      width="55" />

      <el-table-column
        prop="name"
        width="60"
        >
        <template slot-scope="scope">
          <i data-v-959bdaf6="" class="fas fa-user-circle fa-2x" style="color: lightgray;" v-if="!scope.row.image_new"></i>
          <img :src="scope.row.image_new" v-if="scope.row.image_new"  style="max-width:64px"/>
      </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="Name"

        >
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
          <!-- <a :href="scope.row.url" target="_blank">{{scope.row.monthYear}}</a> -->
      </template>
      </el-table-column>

      <el-table-column
        prop="gender"
        label="Gender"
      >
        <template slot-scope="scope">
          <span>{{scope.row.gender}}</span>
      </template>
      </el-table-column>

      <el-table-column
        prop="age"
        label="Age"
      >
        <template slot-scope="scope">
          <span>{{scope.row.age}}</span>
      </template>
      </el-table-column>

      <el-table-column
        prop="time"
        label="Time"
      >
        <template slot-scope="scope">
          <span>{{scope.row.time}}</span>
      </template>
      </el-table-column>

    </el-table>
  </v-layout>
  </v-container>



  <!-- Completed Table -->
   <v-container v-if="appointmentData.Completed.length && appointmentData.Completed[0].name">
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="title" style="margin-bottom:20px;">Completed List</h1>
      </v-flex>
    </v-layout>
      <v-layout row wrap >
    <el-table
      v-loading="isLoading"
      :data="appointmentData.Completed"
      style="width: 100%"
            v-on:row-click="showProfileModal"
      @selection-change="handleSelectionChange"
      >

      <el-table-column
        prop="name"
        width="60"
        >
        <template slot-scope="scope">
          <i data-v-959bdaf6="" class="fas fa-user-circle fa-2x" style="color: lightgray;" v-if="!scope.row.image_new"></i>
          <img :src="scope.row.image_new" v-if="scope.row.image_new"  style="max-width:64px"/>
      </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="Name"

        >
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
          <!-- <a :href="scope.row.url" target="_blank">{{scope.row.monthYear}}</a> -->
      </template>
      </el-table-column>

      <el-table-column
        prop="gender"
        label="Gender"
      >
        <template slot-scope="scope">
          <span>{{scope.row.gender}}</span>
      </template>
      </el-table-column>

      <el-table-column
        prop="age"
        label="Age"
      >
        <template slot-scope="scope">
          <span>{{scope.row.age}}</span>
      </template>
      </el-table-column>

      <el-table-column
        prop="time"
        label="Time"
      >
        <template slot-scope="scope">
          <span>{{scope.row.time}}</span>
      </template>
      </el-table-column>

    </el-table>
  </v-layout>
  </v-container>


  <!-- Waiting Table -->
   <v-container v-if="appointmentData.Waiting.length && appointmentData.Waiting[0].name">
    <v-layout row wrap>
      <v-flex xs12>
        <h1 class="title" style="margin-bottom:20px;">Waiting List</h1>
      </v-flex>
    </v-layout>
      <v-layout row wrap >
    <el-table
      v-loading="isLoading"
      :data="appointmentData.Waiting"
      v-on:row-click="showProfileModal"
      @selection-change="handleSelectionChange"
      style="width: 100%">

     <el-table-column
        prop="name"
        width="60"
        >
        <template slot-scope="scope">
          <i data-v-959bdaf6="" class="fas fa-user-circle fa-2x" style="color: lightgray;" v-if="!scope.row.image_new"></i>
          <img :src="scope.row.image_new" v-if="scope.row.image_new"  style="max-width:64px"/>
      </template>
      </el-table-column>

      <el-table-column
        prop="name"
        label="Name"

        >
        <template slot-scope="scope">
          <span>{{scope.row.name}}</span>
          <!-- <a :href="scope.row.url" target="_blank">{{scope.row.monthYear}}</a> -->
      </template>
      </el-table-column>

      <el-table-column
        prop="gender"
        label="Gender"
      >
        <template slot-scope="scope">
          <span>{{scope.row.gender}}</span>
      </template>
      </el-table-column>

      <el-table-column
        prop="age"
        label="Age"
      >
        <template slot-scope="scope">
          <span>{{scope.row.age}}</span>
      </template>
      </el-table-column>

      <el-table-column
        prop="time"
        label="Time"
      >
        <template slot-scope="scope">
          <span>{{scope.row.time}}</span>
      </template>
      </el-table-column>

    </el-table>
  </v-layout>
  </v-container>

     <h1 v-if="!appointmentData.Completed.length && !appointmentData.Queue.length   && !appointmentData.Waiting.length" class="title" style="text-align:center; margin-top:50px;">No Appointments available</h1>

     <v-dialog max-width="800px" v-model="dialogVisible">
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ExistingRegistration :selectedPatients="selectedPatient"></ExistingRegistration>
    </v-card>
  </v-flex xs12>
</v-dialog>
<v-dialog max-width="800px" v-model="dialogProfileVisible" :lock-scroll="true" :scrollable="true" >
  <v-flex xs12>
    <v-card class="the--card">
      <v-layout row wrap>
        <v-flex xs12>
          <v-btn icon @click.native="dialogProfileVisible = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <ViewProfile :manageProfile="!dialogProfileVisible" :selectedPatients="selectedPatient"></ViewProfile>
    </v-card>
  </v-flex xs12>
</v-dialog>

</v-layout>
</template>
<script>
import $ from "jquery";
import { mapState } from "vuex";
import { api } from "../api.js";
import { formatDate } from "../util.js";
import { get, post } from "axios";
import axios from 'axios';
import ExistingRegistration from './ExistingRegistration';
import ViewProfile from './viewProfile';
import { Notification } from 'element-ui';

const queryString = require("query-string");

export default {
  userName: "",
  components: {
    ExistingRegistration,
    ViewProfile
    // NOTE: don't forget to add components here after import
    // sample in next line
    // VueGoogleAutocomplete
  },
  beforeRouteLeave: (to, from, next) => {
    // NOTE: add any action to be performed before leaving the route here
    // the next() is important
    // so add everything before next()
    // sample in next line
    // console.log("Loggin before leaving route");
    next();
  },
  data() {
    return {
      appointmentData: {
        Completed: [],
        Queue: [],
        Waiting: []
      },
      isLoading: false,
      snackbar: false,
      snackbarColor: "",
      mode: "",
      timeout: 6000,
      snackbarText: "Hello, I'm a snackbar",
      currentPage: 1,
      searchTerm: "",
      dateRange: {},
      responseData: [],
      dialogVisible: false,
      dialogProfileVisible: false,
      selectedPatient: {},
      queueListSelections: []

    }; // return statement end
  }, // data() end
  mounted() {
    // NOTE: add actions to be performed on-mount
    this.getData();
  },
  computed: {
    appointmentDate: function() {
      return this.$route.params.date;
    }
  },
  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.queueListSelections = val;
    },
    cancelAppointments(){

      // console.log(this.queueListSelections )
      const payload = {
        id: this.queueListSelections.map(item => item.id)
      }
      axios.put(`${api}/v2/appointments`, payload).then(()=>{
          Notification({
            title: 'Appointments',
            message: `Appointments have been removed`,
            type: 'success'
          })

        this.getData();

      })
    },
    showProfileModal(row, event, column){
     console.log(row);
     const patient = row;
      this.selectedPatient = patient;
      this.dialogProfileVisible = true;
    },
    getData() {
      this.isLoading = true;
      get(
        api +
          `/appointment_new?clinic_id=${localStorage.clinic_id}&date=${
            this.appointmentDate
          }`
      )
        .then(res => {
          console.log(res.data);
          this.appointmentData = res.data;

          if(res.data.Queue.length && 'info' in res.data.Queue[0] ) {
            this.appointmentData.Queue = res.data.Queue[0].info;
          }
          this.isLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.isLoading = false;
        });
    }
  }
};
</script>

<style lang="css" >
.el-table__row{
  /* display: none; */
}

.el-table__row:hover{
  cursor: pointer;
  /* display: none; */
}
</style>

<style lang="css" scoped>
.title {
  margin-top: 10px;
}
.el-input {
  width: 10px;
  margin: auto;
}
.addWrapper {
  text-align: center;
  display: flex;
  justify-content: center;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  align-items: center;
}
.add {
  /* padding: 3rem 0; */
}
.billingModule {
  min-height: 99vh;
}

#example-1 {
  font-size: 20px;
  padding: 20px;
  margin-left: 1.5rem;
}

#example-2 {
  /*padding: 20px;*/
}

#detail {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 30%; */
  margin-left: 2rem;
}

#charge {
  border: 1px solid #d8d8d8;
  /* border-radius: 4px; */
  padding: 8px;
  /* width: 15%; */
  /* margin: 10px; */
}

#qty {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin: 10px;
  padding: 8px;
  /* width: 10%; */
}

.listOfCharges {
  display: flex;
}

#partiallyPaid {
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  padding: 8px;
  width: 15%;
}

/* .card__title {
  background-color: #018FFF;
  color: white;
  font-size: 80px;
} */

ul {
  list-style: none;
}

.fa-times-circle-o {
  color: #8080808a;
}

.invoiceTotals {
  padding: 20px;
  margin-left: 1.5rem;
  text-align: right;
  padding-right: 5rem;
}

.invoiceTotals > h3 {
  margin: 10px 0px;
}

.sidebar {
  background-color: #383b3f;
  color: #fff;
}

.sidebar ul li {
  padding: 1rem;
}

.sidebar ul li a {
  color: white;
  text-decoration: none;
}

.sidebar .active {
  background-color: #f2994a;
}

.patient_profile > h4 {
  padding: 10px 10px 2px 10px;
}

.patient_profile > h5 {
  padding: 0 10px 10px;
}

.fa-inr {
  margin-left: 1rem;
  margin-right: 0.5rem;
}

.card__actions {
  justify-content: flex-start;
  padding: 16px;
}

.autocompleteSelect {
  width: 65%;
}
</style>



// WEBPACK FOOTER //
// src/components/AppointmentsOn.vue